import Vue from 'vue';
import VueRouter, { Route } from 'vue-router';
import { RouteConfig } from 'vue-router';

Vue.use(VueRouter);

const routes: RouteConfig[] = [
    {
        path: '/p/:slug/:cardId?',
        name: 'publicIdeaPortal',
        component: () => import(/* webpackChunkName: "publicIdeaPortal" */ '../pages/publicIdeaPortal/PublicIdeaPortal.vue'),
        props: (route) => ({
            slug: route.params.slug,
            cardId: route.params.cardId
        }),
    },

];

routes.push({
    path: '*',
    component: () => import(/* webpackChunkName: "PageNotFound" */ '@/PageNotFound.vue'),
});

const router = new VueRouter({
    mode: 'history',
    //base: process.env.BASE_URL,
    routes,
});

let lastPage: Route = null;
router.afterEach((to, from) => {
    lastPage = from;
});

export const goBack = () => {
    if (lastPage != null && lastPage != router.currentRoute) {
        router.push(lastPage.fullPath);
    } else {
        router.push('/');
    }
};

export default router;
